import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function MaxPainChart({ data, maxPain, index }) {
  if (!data?.length) return null;

  // const chartData = {
  //   labels: data.map((d) => d.strike),
  //   // datasets: [
  //   //   {
  //   //     label: "Put OI",
  //   //     data: data.map((d) => d.putOI),
  //   //     backgroundColor: "#fb7185", // soft red
  //   //     borderRadius: 6,
  //   //     barThickness: 10,
  //   //   },
  //   //   {
  //   //     label: "Call OI",
  //   //     data: data.map((d) => d.callOI),
  //   //     backgroundColor: "#34d399", // soft green
  //   //     borderRadius: 6,
  //   //     barThickness: 10,
  //   //   },
  //   // ],
  //   datasets: [
  //     {
  //       label: "Call OI",
  //       data: data.map((d) => d.callOI),
  //       backgroundColor: data.map((d) => (d.isMaxPain ? "#2563eb" : "#34d399")),
  //       borderRadius: 6,
  //     },
  //     {
  //       label: "Put OI",
  //       data: data.map((d) => Math.abs(d.putOI)),
  //       backgroundColor: data.map((d) => (d.isMaxPain ? "#2563eb" : "#fb7185")),
  //       borderRadius: 6,
  //     },
  //   ],
  // };
  // const chartData = {
  //   labels: data.map((d) => d.strike), // ✅ STRIKE PRICES ON X AXIS
  //   datasets: [
  //     {
  //       label: "Call OI",
  //       data: data.map((d) => d.callOI),
  //       backgroundColor: data.map((d) => (d.isMaxPain ? "#2563eb" : "#22c55e")),
  //       borderRadius: 6,
  //     },
  //     {
  //       label: "Put OI",
  //       data: data.map((d) => d.putOI),
  //       backgroundColor: data.map((d) => (d.isMaxPain ? "#2563eb" : "#fb7185")),
  //       borderRadius: 6,
  //     },
  //   ],
  // };
  const chartData = {
    labels: data.map((d) => d.strike), // ✅ STRIKE ONLY
    datasets: [
      {
        label: "Put OI",
        data: data.map((d) => d.putOI),
        backgroundColor: data.map(
          (d) => (d.isMaxPain ? "#2563eb" : "#fb7185") // blue for max pain
        ),
        borderRadius: 6,
        barPercentage: 0.9,
        categoryPercentage: 0.9,
      },
      {
        label: "Call OI",
        data: data.map((d) => d.callOI),
        backgroundColor: data.map((d) => (d.isMaxPain ? "#2563eb" : "#22c55e")),
        borderRadius: 6,
        barPercentage: 0.9,
        categoryPercentage: 0.9,
      },
    ],
  };

  // const options = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       position: "top",
  //       labels: {
  //         usePointStyle: true,
  //         boxWidth: 8,
  //       },
  //     },
  //     tooltip: {
  //       callbacks: {
  //         title: (items) => {
  //           const strike = items[0].label;
  //           const diff = strike - maxPain;

  //           return diff === 0
  //             ? `Strike: ${strike} (MAX PAIN)`
  //             : `Strike: ${strike} (${diff > 0 ? "+" : ""}${diff})`;
  //         },
  //         label: (ctx) => `${ctx.dataset.label}: ${ctx.raw.toLocaleString()}`,
  //       },
  //     },

  //     // tooltip: {
  //     //   callbacks: {
  //     //     label: (ctx) =>
  //     //       `${ctx.dataset.label}: ${Math.abs(ctx.raw).toLocaleString()}`,
  //     //   },
  //     // },
  //     // tooltip: {
  //     //   callbacks: {
  //     //     title: (items) => {
  //     //       const d = data[items[0].dataIndex];
  //     //       return `Strike: ${d.strike}`;
  //     //     },
  //     //     label: (ctx) =>
  //     //       `${ctx.dataset.label}: ${Math.abs(ctx.raw).toLocaleString()}`,
  //     //   },
  //     // },
  //   },

  //   // scales: {

  //   //   x: {
  //   //     ticks: {
  //   //       callback: (value, index) => {
  //   //         const d = data[index];
  //   //         if (!d) return "";
  //   //         return d.strikeDiff === 0
  //   //           ? `${d.strike}` // Max Pain
  //   //           : `${d.strikeDiff > 0 ? "+" : ""}${d.strikeDiff}`;
  //   //       },
  //   //     },
  //   //   },
  //   //   y: {
  //   //     grid: { color: "#e5e7eb" },
  //   //     ticks: {
  //   //       callback: (v) => `${Math.abs(v / 1000)}K`,
  //   //     },
  //   //   },
  //   // },
  //   scales: {
  //     x: {
  //       grid: { display: false },
  //       ticks: {
  //         callback: (value) => value, // keep it simple
  //       },
  //     },
  //     y: {
  //       beginAtZero: true,
  //       ticks: {
  //         callback: (v) => `${(v / 1000).toFixed(0)}K`,
  //       },
  //     },
  //   },
  // };
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { usePointStyle: true },
      },
      tooltip: {
        callbacks: {
          title: (items) => {
            const strike = items[0].label;
            return strike === maxPain
              ? `Strike ${strike} (MAX PAIN)`
              : `Strike ${strike}`;
          },
          label: (ctx) => `${ctx.dataset.label}: ${ctx.raw.toLocaleString()}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        grid: { color: "#e5e7eb" },
        ticks: {
          callback: (v) => `${(v / 1000).toFixed(0)}K`,
        },
      },
    },
  };

  return (
    <>
      <div style={{ height: "420px" }}>
        <Bar data={chartData} options={chartOptions} />
      </div>

      {/* <div
        style={{
          margin: "1rem 0",
          padding: "14px",

          borderRadius: "10px",
          textAlign: "center",
          fontWeight: 600,
        }}
        className="max-pain-span"
      >
        Max Pain for{" "}
        <span className="max-pain-span" style={{ color: "#2563eb" }}>
          {index}
        </span>{" "}
        is{" "}
        <span
          style={{
            background: "#2563eb",
            color: "white",
            padding: "6px 12px",
            borderRadius: "8px",
            marginLeft: 6,
          }}
        >
          {maxPain}
        </span>
      </div> */}
    </>
  );
}
